import React, {Component} from 'react';
import { connect } from 'react-redux';
import iconPath from "../../../helpers/iconHelper";
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { userInfo } from 'os';
//import firebase from 'firebase/app';
import 'firebase/database'; // If using Firebase database
import 'firebase/storage';  // If using Firebase storage
import firebase from '../../../../src/config';
import {Pageloader} from "../../Pageloader";
import { chatloader, loader} from '../../../actions/utils';
import { getChatlist, updateReadChat, saveChat, deleteChat, updateChatSearch} from "../../../actions/chatAction";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import FileUploader from "react-firebase-file-uploader";
import Modal from "react-responsive-modal";
import moment from 'moment';
import $$ from 'jquery';
import "../ChatContainer.css"
import Giffy from "./Giffy";
import Giffy2 from "./Giffy2";
import { CircularProgress } from '@material-ui/core';
import { getlanguagelist } from "../../../helpers/changelanguage";
import { confirmAlert } from 'react-confirm-alert';
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import regeneratorRuntime from "regenerator-runtime";
import Linkify from 'react-linkify';

//firebase.initializeApp(firebaseConfig);
class ChatBody extends Component {
    constructor(props) {
      super(props);
      this.state = {
        chatlist                    : [],
        list                        : [],
        list_key                    : [],
        message                     : '',
        current_user                : this.props.match.params.id,
        firebase_message_pagination : 1,
        is_new                      : false,
        media_link                  : null,
        media_type                  : 'text',
        show_chat                   : 'none',
        chat_node                   : '0',
        avatar                      :  "",
        isUploading                 : false,
        progress                    : 0,
        avatarURL                   : "",
        chat_user_image             : iconPath['DEFAULTUSER'],
        chat_user_membership        : 'BASIC',
        delindex                    : null,
        typingStatus                : false,
        uploadSpinner               : false,
        overFlow                    : 'msg_history_ovrflow',
        visibility                  : 'hidden',
        giffyOpen                   : false,
        serchchatfield              : '',
        serchchat                   : null,
        issearch                    : 0,
        pagination                  : 0,
        loader                      : 'block',
        last_res_counter            : 0,
        search_right_icon           : '',
        filesize                    : 0,
        firebase_auth_token         : localStorage.getItem('userDetails') 
       
      };
      this.initializeChat       = this.initializeChat.bind(this);
      this.doChat               = this.doChat.bind(this);
     // this.myFunction         = this.myFunction.bind(this); 
      this.createChat           = this.createChat.bind(this);
    
      this.removeImage          = this.removeImage.bind(this);
      this.delIcon              = this.delIcon.bind(this);
      this.delChat              = this.delChat.bind(this);
      this.overFlow             = this.overFlow.bind(this);
      this.myFunction           = this.myFunction.bind(this);
      this.chk_scroll           = this.chk_scroll.bind(this);
      this.chk_scroll_user      = this.chk_scroll_user.bind(this);
      this.openGiffy            = this.openGiffy.bind(this);
      this.selectGif            = this.selectGif.bind(this);
      this.serchChat            = this.serchChat.bind(this);
      this.getChatlist          = this.getChatlist.bind(this);
      this.doSearch             = this.doSearch.bind(this);
      this.doblankSearch        = this.doblankSearch.bind(this);
      this.openApp              = this.openApp.bind(this);
      this.onTextMouseOver      = this.onTextMouseOver.bind(this);
      this.onCustomImageUpload  = this.onCustomImageUpload.bind(this);
      this.uploadFile           = this.uploadFile.bind(this);
      
    }
    onTextMouseOver(index){
        $$('#text_msg_'+index).children('a').attr('target', '_blank');
    }

    selectGif(gifurl){
        this.setState({
            avatarURL  : gifurl,
            media_type : 'gif',
            giffyOpen  : false
        });
    }
    
    overFlow(type){
    if(type == 'show'){
        this.setState({
            overFlow : ''
        });
    }else{
        this.setState({
            overFlow : 'msg_history_ovrflow'
        });    
    }
    }
    openGiffy(){
    this.setState({
        giffyOpen : (this.state.giffyOpen == true) ? false : true
    }) 
    }

    onCustomImageUpload(e){
        
        let  languagelist = getlanguagelist();

        let file = e.target.files[0];
        
        if(file.type.includes("image")){
            let sizeInMB = (e.target.files[0].size / (1024*1024)).toFixed(2);
            if(sizeInMB > 2){
                ToastsStore.error(languagelist.validimage);
            }else{
                this.uploadFile(file);
            }
        }else{
            
            var video = document.createElement('video');
            video.preload = 'metadata';
            var obj = this;
            video.onloadedmetadata = function() {
                window.URL.revokeObjectURL(video.src);
                if (video.duration > 120) {
                    ToastsStore.error(languagelist.validvedio);
                }else{
                    obj.uploadFile(file);
                }
                //obj.preview(file);
            }
            video.src = URL.createObjectURL(file);          
        }

    }

    uploadFile(file){
        this.setState({ uploadSpinner: true});

        let today = new Date();
        let date = today.getFullYear()+''+(today.getMonth()+1)+''+today.getDate();
        let time = today.getHours()+''+today.getMinutes() +''+ today.getSeconds();
        let datetime = date+''+time;

        let filename = file.name;
        let filenameArr = filename.split('.');
        let name_len = filenameArr.length;
        let newfileName = 'chat'+datetime+'.'+filenameArr[name_len-1];
        
        filename = newfileName;

        if(filename.includes('JPG') == true || filename.includes('PNG') == true || filename.includes('JPEG') == true || filename.includes('png') == true || filename.includes('jpg') == true){
            this.setState({
                media_type  : 'image'
            })
        }
        if(filename.includes('mp4') == true || filename.includes('m4v') == true){
            this.setState({
                media_type  : 'video'
            })
        }
        if(filename.includes('mp3') == true){
            this.setState({
                media_type  : 'audio'
            })
        }
       
        this.setState({ avatar: filename, progress: 100, isUploading: false });
        const storage       =   firebase.storage();
        const uploadTask    =   storage.ref(this.state.chat_node+'/'+filename).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
              // progress function ...
              const progress = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              );
              console.log('progress :: ',progress);
              this.setState({ progress });
            },
            error => {
              // Error function ...
              console.log('error :: ',error);
            },
            () => {
              // complete function ...
                storage
                    .ref(this.state.chat_node)
                    .child(filename)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({ avatarURL: url, uploadSpinner : false});
                    });
            }
        );
    }
    
    removeImage(){
        this.setState({ avatarURL: '' });
    }
    componentDidMount() { 
        $$('body').removeClass('login_page');
        this.getChatlist();
        $$('#msg_history').bind('scroll',this.chk_scroll);
        $$('.inbox_chat').bind('scroll',this.chk_scroll_user);
        //$$('#text_msg').children('a').attr('target', '_blank');
      /*  $('#msg_history').scroll(function() {
            if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) { 
                this.setState({
                    visibility : 'visible'
               });
            } 
        });  */
        
    }
    componentWillUnmount() {
        localStorage.setItem('apicall','0');
    }
    getChatlist(){
        localStorage.setItem('apicall','1');
        let param = {
          search     : this.state.serchchat,
          pagination : this.state.pagination
        }
        this.props.getChatlist(param);
    }
    chk_scroll_user(e){
       
        var elem = $(e.currentTarget);
        if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight())
        {  
            if((this.state.last_res_counter >= 24) && (localStorage.getItem('apicall') == '0')){
                this.setState({
                    loader     : 'block',
                    pagination : this.state.pagination + 1
            },function(){
                    this.getChatlist();
            });
            }
        }
       
    }
    chk_scroll(e){
        var elem = $(e.currentTarget);
        
        if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight())
        {  
            this.setState({
                visibility : 'visible'
           });
        }
    } 
    initializeChat(){
        this.setState({
            visibility : 'hidden'
       }); 
      let chatlist = this.state.chatlist || []; 
      if(chatlist.length > 0){
        //  console.log(this.state.current_user);
        let matchedIndex =    chatlist.map(function (obj) { return obj.chat_id; }).indexOf(this.state.current_user);
        if(matchedIndex < 0){
            matchedIndex =    chatlist.map(function (obj) { return obj.receiver; }).indexOf(this.state.current_user);
        }
       // console.log('index',matchedIndex);
        if(matchedIndex >= 0){
            //console.log(chatlist[matchedIndex].image_name);
            this.setState({ chat_user_image      : chatlist[matchedIndex].image_name, 
                            chat_user_membership : chatlist[matchedIndex].chat_membership
                         })
        }
       
     }
    
    chatloader(true);
       let me              = parseInt(this.props.me.id); 
       let myfriend        = parseInt(this.state.current_user);
       let chatcombination = (me > myfriend) ? `${myfriend}_${me}` : `${me}_${myfriend}`;
      // console.log(chatcombination);
       this.setState({
        chat_node : chatcombination
       });
       const userdetails  = sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails');
       let userdetailsArr = JSON.parse(userdetails);
       firebase.auth().signInWithCustomToken(userdetailsArr.firebase_auth_token)
      .then((userCredential) => {
   
            var user = userCredential.user;
            this.messageRef     = firebase.database().ref().child('MsgCovrsn').child(chatcombination).child('msg');
            this.messageRef2    = firebase.database().ref().child('MsgCovrsn').child(chatcombination);
            this.listenMessages();
        })
        .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorMessage);
        ToastsStore.error(errorMessage);
        // ...
        });
    }
    createChat(firebase_timestamp){
        let param = {
            receiver_id         : this.state.current_user,
            message             : this.state.message,
            date_time           : (moment().format('YYYY-MM-DD HH:mm:ss')),
            media_link          : this.state.avatarURL,
            media_type          : this.state.media_type.toUpperCase(),
            firebase_timestamp  : firebase_timestamp
        };
        this.props.saveChat(param);
    }
    doChat(sender_id,user){
        this.setState({
            visibility : 'hidden'
        });
        if(sender_id != this.state.current_user){
            if((user.view_status == 0) && (user.receiver == 'receiver')){
                this.props.updateReadChat({sender_id:user.chat_id,timestamp:Math.floor(Date.now() / 1000)});
            }else{
                this.props.history.push(`/chat/${sender_id}`);
                this.setState({
                    current_user                : sender_id,
                    firebase_message_pagination : 1
                },function(){
                    this.initializeChat();
                });
            }
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps,prevProps,prevState){  
        let chats = this.state.chatlist;
        //console.log('chats ', chats);
        if(this.props.chatlist != nextProps.chatlist){

            if (this.state.pagination == 0) {
                chats =  [...nextProps.chatlist];
            }else{
                let nextchats = nextProps.chatlist;
                
                if(nextchats !== this.props.chatlist){
                  Object.keys(nextchats).map((key) => {
                    chats.push(nextchats[key]);
                  });
                }
            }
            //console.log('2 chats ', chats);
          //  console.log(this.state.serchchat);
            this.setState({
                search_right_icon           : ((this.state.serchchat != null) && (this.state.serchchat != '')) ? 'cross' : '',
                last_res_counter            : nextProps.chatlist.length,
                chatlist                    : chats,
                loader                      : 'none',
                firebase_message_pagination : 1
            },function(){
                localStorage.setItem('apicall','0');
                if(nextProps.chatlist.length > 0){
                    if(this.state.serchchat != null){
                        
                        this.setState({
                            current_user                : (this.state.chatlist[0].chat_id != '') ? this.state.chatlist[0].chat_id : this.state.chatlist[0].receiver,
                            firebase_message_pagination : 1
                        },function(){ 
                       
                            if(this.state.pagination == 0){
                                this.initializeChat();
                            }
                        })
                    }else{
                        /* this.setState({
                            current_user                : (this.state.chatlist[0].chat_id != '') ? this.state.chatlist[0].chat_id : this.state.chatlist[0].receiver,
                            firebase_message_pagination : 1
                        },function(){ 
                       
                            if(this.state.pagination == 0){
                                this.initializeChat();
                            }
                        }) */
                       if(this.state.pagination == 0){

                            //current_user                : (this.state.chatlist[0].chat_id != '') ? this.state.chatlist[0].chat_id : this.state.chatlist[0].receiver,
                            this.initializeChat();
                        } 
                       
                    }
                }
                               
            });
        }
       if(nextProps.readchat2 != this.props.readchat2){
            this.props.history.push(`/chat/${nextProps.readchat2.sender_id}`);
            this.setState({
                current_user                : nextProps.readchat2.sender_id,
                firebase_message_pagination : 1
            },function(){
                this.initializeChat();
            });
        }
        if(nextProps.deletechat != this.props.deletechat){
            if(nextProps.deletechat.res == 1){
                this.messageRef.child(this.state.list_key[this.state.delindex]).update({
                    delete_status : true,
                });
            }else{
                ToastsStore.error('Message cannot be deleted')
            }
        }
       
        if(this.state.current_user != nextProps.match.params.id){
           this.props.history.push(`/chat/${nextProps.match.params.id}`);
            this.setState({
                current_user                : nextProps.match.params.id,
                firebase_message_pagination : 1
            },function(){
               // this.initializeChat();
            }); 
       }
    }
    handleChange(event) {
        this.setState({message: event.target.value});
    }
    myFunction(){
     
    } 
    handleSend() {
      
        if (this.state.message!= '' || this.state.avatarURL!= '') {
         
            var newItem = {
                content       : {text: this.state.message, 
                                 type: this.state.media_type, 
                                 url: this.state.avatarURL, 
                                 videoThumbUrl: this.state.avatarURL},
                delete_status : false,
                senderId      : this.props.me.id,
                timestamp     : Math.floor(Date.now()/ 1000).toString()
            }
            
            if(this.state.is_new == false){   
                this.messageRef2.set( {
                    [`${this.props.me.id}_isTyping`] : false,
                    [`${this.props.me.id}_timestamp`] : Math.floor(Date.now() / 1000),
                    [`${this.state.current_user}_isTyping`] : false,
                    [`${this.state.current_user}_timestamp`] : Math.floor(Date.now() / 1000),
                    msg                                      : null
                    
                });
                this.messageRef.push(newItem);
               
            }else{
                this.messageRef2.update( {
                    [`${this.props.me.id}_isTyping`] : false,
                    [`${this.props.me.id}_timestamp`] : Math.floor(Date.now() / 1000),
                    [`${this.state.current_user}_isTyping`] : false,
                    [`${this.state.current_user}_timestamp`] : Math.floor(Date.now() / 1000),
                    
                });
                this.messageRef.push(newItem);
            }
            this.createChat(newItem.timestamp);
            this.setState({ message: '' , avatarURL : ''});
        }
    }
    handleKeyPress(event) {
    if (event.key !== 'Enter'){ 
        if(this.state.is_new == false){   
            this.messageRef2.set( {
                [`${this.props.me.id}_isTyping`] : true,
                [`${this.props.me.id}_timestamp`] : Math.floor(Date.now() / 1000),
                [`${this.state.current_user}_isTyping`] : false,
                [`${this.state.current_user}_timestamp`] : Math.floor(Date.now() / 1000),
                
            });
        }else{
            this.messageRef2.update( {
                [`${this.props.me.id}_isTyping`] : true,
                [`${this.props.me.id}_timestamp`] : Math.floor(Date.now() / 1000),
                [`${this.state.current_user}_isTyping`] : false,
                [`${this.state.current_user}_timestamp`] : Math.floor(Date.now() / 1000),
                
            });
        }
        return;
    }else{

    }
    this.handleSend();
    }
    listenMessages() {
    
        //let msg = (this.messageRef.limitToLast(this.state.firebase_message_pagination * 10));
        this.messageRef2.child(`${this.state.current_user}_isTyping`)
            .on('value', message2 => {
                this.setState({
                    typingStatus : message2.val()
                })
            });
        //let msg = (this.messageRef.limitToLast(this.state.firebase_message_pagination * 5));
    
        this.messageRef
            .on('value', message => {
            this.setState({
                list                        : (message.val() != null) ? Object.values(message.val()) : [],
                list_key                    : (message.val() != null) ? Object.keys(message.val()) : [],
                firebase_message_pagination : this.state.firebase_message_pagination + 1,
                is_new                      : (message.val() != null) ? true : false,
            },function(){
            
                if( $$('#msg_history').prop("scrollHeight") == $$('#msg_history').outerHeight()){
                        this.setState({
                            visibility : 'visible'
                        });
                        
                }else{
                        $$("#msg_history").animate({ scrollTop: $$('#msg_history').prop("scrollHeight")});
                }
                loader(false);
                
                //$$('#text_msg').children('a').attr('target', '_blank');
            });
        });
       
    }

    delIcon(type,id){
        if($$(`#delicon_${id}`).hasClass("is-collapsed")){
            $$(`#delicon_${id}`).removeClass('is-collapsed');
        }else{
            $$(`#delicon_${id}`).addClass('is-collapsed');
        }
    }
    delChat(index,timestamp){
        let languagelist = getlanguagelist();
        let param = {
            firebase_timestamp : timestamp,
            receiver_id        : this.state.current_user
        }

        confirmAlert({
            title: languagelist.cofirm,
            message: languagelist.sure,
            buttons: [
              {
                label: languagelist.yes,
                onClick: () => {
                    this.setState({
                        delindex : index
                    },function(){
                        this.props.deleteChat(param);
                    })
                }
              },
              {
                label: languagelist.no,
                onClick: () => {
                    $$(`#delicon_${index}`).removeClass('is-collapsed');
                    return false;
                }
              }
            ]
          });
       
    }
    serchChat(e){
        this.setState({
            [e.target.name]: e.target.value,
        });
    }
    doSearch(){
        this.setState({
            loader         : 'block',
            serchchat      : this.state.serchchatfield,
            pagination     : 0
        },function(){
            if(this.state.serchchat.length >= 3) 
            {
                this.getChatlist();
            }
            if(this.state.serchchat == '') 
            {
                this.getChatlist();
            }
        })
    }
    doblankSearch(){
        this.setState({
            loader         : 'block',
            serchchat      : '',
            serchchatfield : '',
            pagination     : 0
        },function(){
            if(this.state.serchchat == '') 
            {
                this.getChatlist();
            }
        })

    }

    openApp(){
        $("#appModal").modal('show');
    }
   
   
    render() {
        let devider_date = '';
        let show  = 'YES';
        let chatlist =  this.state.chatlist || [];
        let  languagelist = getlanguagelist();
        let options = {
            buttons: {
                backgroundColor: 'rgba(30,30,36,0.8)',
                iconColor: 'rgba(255, 255, 255, 0.8)',
                iconPadding: '5px',
                showAutoplayButton: false,
                showCloseButton: true,
                showDownloadButton: false,
                showFullscreenButton: true,
                showNextButton: true,
                showPrevButton: true,
                showThumbnailsButton: false,
                size: '40px'
            }
        };
        

        return (
            <div className="col-xs-12 post_area post_area_chat">
                <div className="clr20"></div>
                <div className="messaging">
                    <div className="inbox_msg">
                        <div className="inbox_people">
                            <div className="headind_srch">
                                <div className="recent_heading">
                                    <h4>{languagelist.recent}</h4>
                                </div>
                                <div className="srch_bar">
                                    <div className="input-group input-group-sm">
                                        <input 
                                            type="text" 
                                            className="search-bar" 
                                            name="serchchatfield" 
                                            value={this.state.serchchatfield} 
                                            placeholder={languagelist.search_1} 
                                            onChange={this.serchChat}
                                            />
                                            <span className="input-group-btn">
                                                <button type="button" onClick={this.doSearch} className="btn btn-info btn-flat"><i className="fa fa-search" aria-hidden="true"></i></button>
                                                {(this.state.search_right_icon == 'cross') ?
                                                  <button type="button" onClick={this.doblankSearch} className="btn cross-chat"><i className="fa fa-times" aria-hidden="true"></i></button>
                                                 : null
                                                }
                                               
                                            
                                        </span>
                                   
                                    </div>
                                </div>
                               
                            </div>
                           {/*  style={(this.state.avatarURL != '') ? {height : '820px'} : {height : '620px'}} */ }
                            <div className="inbox_chat" >
                                {
                                    chatlist.map((chat,index) =>{
                                        let  new_class = '';
                                        if(chat.chat_id == this.state.current_user){
                                            new_class = 'active_chat';
                                        }else if(chat.view_status == 0){
                                            new_class = 'new_chat';
                                        }else if((this.state.current_user == 0) && (chat.type == "ADMIN CHAT")){
                                            new_class = 'active_chat';
                                        }else{
                                            new_class = '';
                                        }
                                        return (
                                            <div className={`chat_list ${new_class}`} key={`chat_${index}`} onClick={()=>this.doChat((chat.chat_id != '') ? chat.chat_id : chat.receiver,chat)}>
                                                <div className="chat_people">
                                                    <div className="chat_img"> 
                                                        <img className={(chat.chat_membership == 'GOLD') ? "gold_user" : ''} src={chat.image_name} alt={chat.chat_name} onError = {(e) => {
                                                            e.target.src = iconPath['DEFAULTUSER']
                                                        }} /> 
                                                    </div>
                                                    <div className="chat_ib">
                                                        <h5>{chat.chat_name} 
                                                        {
                                                            (chat.created_at != '') ?
                                                            <span className="chat_date">{(moment(chat.created_at).format('MMM Do YY'))}</span>
                                                            : null
                                                        }
                                                        <br/>
                                                        {
                                                            (this.state.typingStatus == true) ?
                                                            <i>typing..</i>
                                                            : null
                                                        }
                                                        </h5>
                                                        <p>
                                                        {(chat.media_type == '') ?
                                                            chat.message.substring(0, 100)
                                                            : 
                                                            <i className="fa fa-paperclip">{chat.media_type}</i>
                                                        } 
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )

                                    })
                                }
                                
                                <div id="chatloader" style={{display : `${this.state.loader}`}}>
                                    <CircularProgress />
                                </div>
                            </div>
                        </div>
                        <div className="mesgs">
                            <Modal open={this.state.giffyOpen} onClose={this.openGiffy} showCloseIcon={false} center>

                            
                                 <Giffy2 
                                    selectGif = {this.selectGif}
                                    opengiffy = {this.openGiffy}
                                />
                            
                            </Modal>
                           {/*  <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} lightBackground /> */}
                            <SimpleReactLightbox>
                                <div className={`msg_history ${this.state.overFlow}`} id="msg_history"  name="msg_history" 
                                    onMouseEnter={() => this.overFlow('show')}
                                    onMouseLeave={() => this.overFlow('hide')}
                                    style={{visibility : this.state.visibility}} 
                                >
                                    <SRLWrapper options={options}>
                                
                                        {  this.state.list.map((item, index) => {
                                                                                   
                                            if(devider_date != (moment(item.timestamp * 1000).format('DD/MM/YYYY'))){
                                                show = 'YES';
                                                devider_date = (moment(item.timestamp * 1000).format('DD/MM/YYYY'))
                                            }else{
                                                show = 'NO';
                                            }
                                            if((item.delete_status == false) || (item.delete_status == 'false')){
                                                return(
                                                
                                                    <div key={`chatbody_${index}`} className="message-sec">
                                                        {
                                                            (show == 'YES') ? 
                                                            <p className="massage_divider"><span>{devider_date}</span></p>
                                                            : null
                                                        }
                                                    
                                                        {(item.senderId == this.props.me.id) ? 
                                                    
                                                        <div className="outgoing_msg" >
                                                            <div className="post_menu_area">
                                                                <input type="text" className="chat_menu"  onClick={() => this.delIcon('show',index)}/>
                                                                    <ul className="chat_menu_list" id={`delicon_${index}`}>
                                                                        <li><a href={void(0)} onClick={()=>this.delChat(index,item.timestamp)}>Delete  </a></li>
                                                                    </ul>
                                                            </div>
                                                            <div className="sent_msg">
                                                                
                                                                    { (item.content.type == 'image') ?
                                                                        
                                                                        <a href={item.content.url} data-attribute="SRL">
                                                                            <img src={item.content.url} className="chat_media"/>
                                                                        </a>
                                                                        
                                                                        : null
                                                                    }
                                                                    { (item.content.type == 'gif') ?
                                                                        
                                                                        <a href={item.content.url} data-attribute="SRL">
                                                                            <img src={item.content.url} className="chat_media"/>
                                                                        </a>
                                                                        
                                                                        : null
                                                                    }
                                                                    { (item.content.type == 'video') ?
                                                                        
                                                                        <video controls className="chat_media" controlsList="download">
                                                                            <source src={item.content.url} type="video/mp4" />
                                                                            Your browser does not support the video tag.
                                                                        </video> 
                                                                            
                                                                        : null
                                                                    }
                                                                    { (item.content.type == 'audio') ?
                                                                        
                                                                        <audio controls >
                                                                            <source src={item.content.url} type="audio/mp3" />
                                                                        </audio>
                                                                        
                                                                        : null
                                                                    }
                                                                    { ((item.content.type == 'audio') || (item.content.type == 'video') ||  (item.content.type == 'gif')  || (item.content.type == 'image')) ?
                                                                        <br/>
                                                                        : null 
                                                                    }
                                                                <div className="clear" />
                                                                {(item.content.text != '') ?
                                                                <p id={`text_msg_${index}`} onMouseOver={() => this.onTextMouseOver(index)}> 
                                                                    {/* <a href={void(0)} className="close" style={{display:'none'}} id={`delicon_${index}`} onClick={()=>this.delChat(index,item.timestamp)}>
                                                                    <i className="fa fa-times-circle" aria-hidden="true"></i>
                                                                    </a> */}
                                                                    <Linkify>
                                                                        {item.content.text}
                                                                    </Linkify>
                                                                </p>
                                                                : null
                                                                }
                                                                <span className="time_date_send">{(moment(item.timestamp * 1000).format('HH:mm a'))}</span> </div>
                                                        </div>
                                                        :
                                                        <div className="incoming_msg">
                                                            <div className="incoming_msg_img chat_img"> 
                                                                <img className={this.state.chat_user_membership == 'GOLD' ? 'gold_user' : ''} src={this.state.chat_user_image} alt="sunil" onError = {(e) => {
                                                                    e.target.src = iconPath['DEFAULTUSER']
                                                                    }}
                                                                /> 
                                                            </div>
                                                            <div className="received_msg">
                                                                <div className="received_withd_msg">
                                                                
                                                                    
                                                                    { (item.content.type == 'image') ?
                                                                        
                                                                        <a href={item.content.url} data-attribute="SRL">
                                                                            <img src={item.content.url} className="chat_media"/>
                                                                        </a>
                                                                        
                                                                        : null
                                                                    }
                                                                    { (item.content.type == 'gif') ?
                                                                        
                                                                        <a href={item.content.url} data-attribute="SRL">
                                                                            <img src={item.content.url} className="chat_media"/>
                                                                        </a>
                                                                        
                                                                        : null
                                                                    }
                                                                    { (item.content.type == 'video') ?
                                                                        
                                                                        <video controls className="chat_media" controlsList="download">
                                                                            <source src={item.content.url} type="video/mp4" />
                                                                            Your browser does not support the video tag.
                                                                        </video> 
                                                                            
                                                                        : null
                                                                    }
                                                                    { (item.content.type == 'audio') ?
                                                                        
                                                                        <audio controls >
                                                                            <source src={item.content.url} type="audio/mp3" />
                                                                        </audio>
                                                                        
                                                                        : null
                                                                    }
                                                                    { ((item.content.type == 'audio') || (item.content.type == 'video') ||  (item.content.type == 'gif')  || (item.content.type == 'image')) ?
                                                                        <br/>
                                                                        : null 
                                                                    }
                                                                    <div className="clear" />
                                                                    {(item.content.text != '') ?
                                                                    <p id={`text_msg_${index}`} onMouseOver={() => this.onTextMouseOver(index)}>
                                                                        {/* {item.content.text} */} 
                                                                        <Linkify>
                                                                            {item.content.text}
                                                                        </Linkify>
                                                                    </p>
                                                                    : null
                                                                    }
                                                                    <span className="time_date">{(moment(item.timestamp * 1000).format('HH:mm a'))}</span></div>
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>
                                                )

                                            }
                                            
                                        })
                                        }
                                    </SRLWrapper>
                                        
                                </div>
                            </SimpleReactLightbox>
                           
                            {(this.state.avatarURL != '') ? 
                            <div className="preview_attach">
                                <ul>
                                    <li>
                                        <a href={void(0)} className="close"  onClick={this.removeImage}>
                                            <i className="fa fa-times-circle" aria-hidden="true"></i>
                                        </a> 
                                        { (this.state.media_type == 'image') ?
                                            <img className="" src={this.state.avatarURL} />
                                            : null
                                        }
                                        { (this.state.media_type == 'gif') ?
                                            <img className="" src={this.state.avatarURL} />
                                            : null
                                        }
                                        { (this.state.media_type == 'video') ?
                                            <video controls className="chat_media" controlsList="nodownload">
                                                <source src={this.state.avatarURL} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video> 
                                            : null
                                        }
                                        { (this.state.media_type == 'audio') ?
                                            <audio controls >
                                                <source src={this.state.avatarURL} type="audio/mp3" />
                                            </audio>
                                            : null
                                        }
                                    </li>
                                    
                                </ul>


                                <div className="clearfix"></div>
                            </div>
                            : null 
                            }
                            <div className="type_msg">
                                
                               
                                <div className="input_msg_write">
                                    <textarea type="text" 
                                           className="write_msg" 
                                           placeholder={languagelist.message1} 
                                           onChange={this.handleChange.bind(this)}
                                           onKeyPress={this.handleKeyPress.bind(this)} 
                                           value = {this.state.message} 
                                           rows="4"
                                    />
                                  
                                   <div className="custom-file">
                                        {
                                            (this.state.uploadSpinner == true) ? 
                                            <i className='fa fa-spinner fa-spin'></i> 
                                            : null
                                        }
                                    
                                       
                                        <label style={{backgroundColor: '#3c8dbc', color: 'white', padding: '7px 9px 9px', borderRadius: '50%', cursor: 'pointer', width : '33px', height : '33px', float : 'right', right: '150px', position: 'absolute', top: '23px'}}>
                                            <i className="fa fa-paperclip" />
                                            <FileUploader 
                                                accept="image/*,video/*"
                                                name="avatar"
                                                randomizeFilename
                                                storageRef={firebase.storage().ref(this.state.chat_node)}
                                                onChange={this.onCustomImageUpload}
                                                className="custom-file-input" 
                                                hidden
                                            /> 
                                        </label>
                                    </div>
                                    {/*onUploadStart={this.handleUploadStart}
                                            onUploadError={this.handleUploadError}
                                            onUploadSuccess={this.handleUploadSuccess}
                                            onProgress={this.handleProgress}*/}
                                   
                                    {/* <Modal
                                        isOpen={this.state.giffyOpen}
                                       
                                        contentLabel="Example Modal" 
                                        className="giffy_modal"
                                    >
                                        <Giffy2 selectGif={this.selectGif}/>
                                    </Modal> */}
                                    

                                    <button className="msg_send_btn4" type="button" onClick={this.openApp}><i className="fa fa-phone"></i></button>  
                                    <button className="msg_send_btn3" type="button" onClick={this.openApp}><i className="fa fa-video-camera"></i></button>
                                    
                                    <button className="msg_send_btn2" type="button"  onClick={this.openGiffy}><i className="fa fa-smile-o"></i></button>  
                                    <button className="msg_send_btn" type="button"  onClick={this.handleSend.bind(this)}><i className="far fa-paper-plane"></i></button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        );
       
    }
}
const mapStateToProps = state => {
  return {
    chatlist   : state.chatuserlist.chatList.list, 
    me         : state.login.user,
    readchat2  : state.readchat.readChat, 
    savechat   : state.createchat.createChat,
    deletechat : state.removechat.removeChat,
    chatsearch : state.chatsearch.chatSearch,
  }
}
const mapDispatchToProps = dispatch => {
  return {

    saveChat         : bindActionCreators(saveChat, dispatch),
    updateReadChat   : bindActionCreators(updateReadChat, dispatch),
    deleteChat       : bindActionCreators(deleteChat, dispatch),
    updateChatSearch : bindActionCreators(updateChatSearch, dispatch),
    getChatlist      : bindActionCreators(getChatlist, dispatch),
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatBody));

